var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-search-8009785",
    d: "M162.27,156a6.27,6.27,0,1,0,3.946,11.135l4.675,4.675a.65.65,0,0,0,.919-.919l-4.675-4.675A6.263,6.263,0,0,0,162.27,156Zm0,1.3a4.973,4.973,0,1,1-4.973,4.973A4.963,4.963,0,0,1,162.27,157.3Z",
    transform: "translate(-156 -156)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSearch);
export default __webpack_public_path__ + "static/media/noun-search.4394590971873902b748c274d1e4438c.svg";
export { ForwardRef as ReactComponent };